Email address to check for candidate profile.
